



















import { Component, Prop, Vue } from 'vue-property-decorator';
import { Phase } from '@/interfaces/Phase';
import LanguageTextInput from '@/components/App/LanguageTextInput.vue';

@Component({
  components: { LanguageTextInput }
})
export default class PhaseListItem extends Vue {
  @Prop()
  phase!: Phase;

  get phaseLanguage() {
    const preferredLanguage = this.phase.phaseLanguages?.find(
      (language: any) => language.languageId === this.$store.state.user.languageId
    );
    if (preferredLanguage) return preferredLanguage;
    return this.phase.phaseLanguages?.[0];
  }

  get name() {
    return this.phaseLanguage?.name;
  }
}
